import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../../../elements-table/table';
import { FormattedMessage, FormattedNumber, injectIntl, intlShape } from 'react-intl';

const SubTotalLineItem = ({subtotal, currency}) => (
  <div className="flex space-between table-row">
    <div className="flex-basis-50">
      <FormattedMessage
        id="hosting.sales_tax_space_rental_table.subtotal"
        defaultMessage="Subtotal"
      />
    </div>
    <div className="flex-basis-50">
      <FormattedNumber
        value={subtotal}
        currency={currency}
        style="currency"
      />
    </div>
  </div>
);

const SalesTaxSpaceRentalLineItem = ({spaceRental, currency}) => (
  <div className="flex space-between table-row">
    <div className="flex-basis-50">
      <FormattedMessage
        id="hosting.sales_tax_space_rental_table.space_rental_sales_tax"
        defaultMessage="Space rental sales tax"
      />
    </div>
    <div className="flex-basis-50">
      <FormattedNumber
        value={spaceRental}
        currency={currency}
        style="currency"
      />
    </div>
  </div>
);

const SpaceRentalLineItem = ({spaceRental, currency}) => (
  <div className="flex space-between table-row heavy">
    <div className="flex-basis-50">
      <FormattedMessage
        id="hosting.sales_tax_space_rental_table.space_rental_total"
        defaultMessage="Total"
      />
    </div>
    <div className="flex-basis-50">
      <FormattedNumber
        value={spaceRental}
        currency={currency}
        style="currency"
      />
    </div>
  </div>
);

const SpaceRentalSalesTaxTableComponent = ({
  spaceRental,
  spaceRentalUsSalesTax,
  spaceRentalTotal,
  currency,
  intl
}) => {
  return (
    <div>
      <h4>
        <FormattedMessage id="hosting.sales_tax_space_rental_table.space_rental" defaultMessage="Space Rental" />
      </h4>
      <Table
        tableHeaders={[{
          label: intl.formatMessage({ id: 'hosting.sales_tax_space_rental_table.space_rental', defaultMessage: 'Space Rental' }),
          classname: 'flex-basis-10 text-transform-none'
        }]}
        tableBody={
          <div>
            <SubTotalLineItem subtotal={spaceRental} currency={currency} />
            {!!spaceRentalUsSalesTax &&
              <>
                <hr className="dotted margin-md-top margin-md-bottom" />
                <SalesTaxSpaceRentalLineItem spaceRental={spaceRentalUsSalesTax} currency={currency} />
              </>
            }
            <hr className="dotted margin-md-top margin-md-bottom" />
            <SpaceRentalLineItem
              spaceRental={spaceRentalTotal}
              currency={currency}
            />
          </div>
        }
      />
    </div>
  );
};

SpaceRentalSalesTaxTableComponent.propTypes = {
  spaceRental: PropTypes.number,
  spaceRentalUsSalesTax: PropTypes.number,
  spaceRentalTotal: PropTypes.number,
  currency: PropTypes.string,
  intl: intlShape
};

export const SpaceRentalSalesTaxTable = injectIntl(SpaceRentalSalesTaxTableComponent);
